function DashboardActiveMainCurrentLap({value}) {
    const lapIcon = {
        "-": "arrow_warm_up",
        "+": "warning",
    }[value["is-delta-positive"]] || "warning";

    const lapIconClass = {
        "-": "material-symbols-outlined text-xs text-acc-green",
        "+": "material-symbols-outlined text-xs text-acc-red",
    }[value["is-delta-positive"]] || "material-symbols-outlined text-xs text-acc-red";

    return (
        <div className="rounded-lg bg-[#233648]/30 p-3 border border-[#324d67]/50">
            <div className="flex justify-between items-center mb-1">
                <span className="text-[10px] uppercase font-bold text-[#92adc9]">Current Lap</span>
                <span className={lapIconClass}>{lapIcon}</span>
            </div>
            <div className="flex justify-between items-end">
                <p className={value["is-valid-lap"] === 1 ? "text-xl font-bold text-acc-green" : "text-xl font-bold text-acc-red"}>{value["current-time"]}</p>
                <p className={value["is-delta-positive"] === "-" ? "text-sm font-bold text-acc-green" : "text-sm font-bold text-acc-red"}>{value["is-delta-positive"]}{value["delta-lap-time"]}</p>
            </div>
        </div>
    );
}

export default DashboardActiveMainCurrentLap;